function initializeTestimonialSwipers(scope = document) {
  const testimonialSwiper = scope.querySelector(".testimonial-swiper");
  if (testimonialSwiper) {
    const swiperNavigationNext = scope.querySelector(
      ".testimonial-swiper-next"
    );
    const swiperNavigationPrev = scope.querySelector(
      ".testimonial-swiper-prev"
    );
    const swiperPagination = scope.querySelector(
      ".testimonial-swiper-pagination"
    );
    new Swiper(".testimonial-swiper", {
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 20,
          centeredSlides: true,
          centeredSlidesBounds: true,
          offsetBefore: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
      navigation: {
        nextEl: swiperNavigationNext,
        prevEl: swiperNavigationPrev,
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
      },
    });
  }
}
